import { FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";

export const email = "cmohamadch@gmail.com";

export const socials = [
	{ label: "LinkedIn", href: "https://www.linkedin.com/in/mohammad-c/", Icon: FaLinkedinIn },
	{ label: "Instagram", href: "https://www.instagram.com/mochr.dev/", Icon: FaInstagram },
	{ label: "X", href: "https://x.com/mohchrf", Icon: BsTwitterX },
];

export const routes = [
	{ title: "About", href: "#about" },
	{ title: "Skills", href: "#skills" },
	{ title: "Projects", href: "#projects" },
	{ title: "Contact", href: "#contact" },
];

